import { FC } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import HistoricModal, {
  HISTORIC_COLUMNS
} from '@component/Parameterization/Shared/HistoricModal'

import ParametroCompra from '@service/ParametroCompra'

const ModalHistoricPurchaseAlcadas: FC = () => {
  const { companieId } = useParametrizationConfigPurchase()
  return (
    <HistoricModal
      title="Histórico Alçadas de Compras"
      empresaId={companieId}
      fetcher={async empresaId =>
        (await ParametroCompra.getAlcadasComprasHistorico(empresaId)).data
          ?.data ?? []
      }
      columns={[
        HISTORIC_COLUMNS.data,
        HISTORIC_COLUMNS.usuario,
        HISTORIC_COLUMNS.empresa,
        HISTORIC_COLUMNS.acao
      ]}
      emptyMessage="Nenhum histórico de alçadas encontrado para esta empresa."
    />
  )
}

export default ModalHistoricPurchaseAlcadas
